var map = {
	"./add.svg": "76a4",
	"./check.svg": "7bae",
	"./checkin.svg": "2f73",
	"./close.svg": "8b1b",
	"./collect.svg": "b197",
	"./defaultDoc.svg": "5f6b",
	"./delete.svg": "0d45",
	"./doc.svg": "3f7d",
	"./download.svg": "f28e",
	"./echo.svg": "b4dd",
	"./eye.svg": "7364",
	"./file_audio.svg": "4b1c",
	"./file_doc.svg": "8151",
	"./file_video.svg": "d17b",
	"./hits.svg": "b323",
	"./info.svg": "76ed",
	"./location.svg": "d2eb",
	"./love.svg": "aac3",
	"./more.svg": "0f4c",
	"./msg.svg": "c051",
	"./nice.svg": "77c6",
	"./play.svg": "dab1",
	"./radio.svg": "c473",
	"./rank.svg": "1686",
	"./reduce.svg": "7030",
	"./report.svg": "effc",
	"./search.svg": "d103",
	"./text.svg": "d36f",
	"./time.svg": "79aa",
	"./update.svg": "5095",
	"./view.svg": "00ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";